import { useMemo } from 'react';

import {
  PreparedWorkload,
  useWoopWorkloadFilters,
} from 'features/workload-optimization';

import {
  kindCriterion,
  namespaceCriterion,
} from '../../../_workloads-list/searchCriteria';
import {
  configuredViaCriterion,
  horizontalOptimizationCriterion,
  verticalOptimizationCriterion,
} from '../../../workloads-list/searchCriteria';

import { makeSearchBoxCriteria } from '@cast/shared-search-ui';

export const useImpactWorkloadsCriteria = () => {
  const { data } = useWoopWorkloadFilters({ optimizedOnly: true });

  return useMemo(
    () => [
      ...makeSearchBoxCriteria<PreparedWorkload>(
        {
          key: 'workloadId',
          title: 'Workload ID:',
          prop: 'id',
          options: data?.workloadIds ?? [],
          allowMultiple: true,
        },
        {
          key: 'workloadName',
          title: 'Workload name:',
          prop: 'name',
          options: data?.workloadNames ?? [],
          allowMultiple: true,
          matcher: 'exact',
        }
      ),
      namespaceCriterion,
      kindCriterion,
      configuredViaCriterion,
      verticalOptimizationCriterion,
      horizontalOptimizationCriterion,
    ],
    [data]
  );
};
